import { useOptionalAppReveal, type BootVisibilityState } from "@/contexts/AppRevealContext";
import { cn } from "@/lib/utils";

export function useBootShellLoading() {
  const reveal = useOptionalAppReveal();
  const bootState: BootVisibilityState = reveal?.bootState ?? "boot_complete";

  const isBootVisible = bootState === "boot_visible";
  const isBootReleasing = bootState === "boot_releasing";
  const isBootComplete = bootState === "boot_complete";

  const shouldRenderShellLoading = isBootComplete;
  const shellLoadingClassName = cn(
    "transition-opacity duration-300 ease-out",
    isBootComplete ? "opacity-100" : "opacity-0 pointer-events-none",
  );

  return {
    bootState,
    isBootVisible,
    isBootReleasing,
    isBootComplete,
    shouldRenderShellLoading,
    shellLoadingClassName,
  };
}
